module.exports = __webpack_public_path__ + "5c65dec53bdea5a4f47182e6b3e7932b.pdf";